export const interestTypes: { [key: string]: string } = {
  not_interested: 'are not interested in',
  not_eligible: 'are not eligible in',
  withdrawInterest: 'want to withdraw interest in',
  interested: 'are interested in',
  archived: 'want to archive',
  unarchive: 'want to unarchive',
};
